module.exports = __webpack_public_path__ + "static/img/kassa24.8db8ce98.svg";